import { Button } from "@/components/ui/button";
import { ArrowLeft, ArrowRight, Check } from "lucide-react";

interface TestNavigationProps {
  currentQuestionIndex: number;
  totalQuestions: number;
  hasCurrentAnswer: boolean;
  isSubmitting: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onSubmit: () => void;
}

export const TestNavigation = ({
  currentQuestionIndex,
  totalQuestions,
  hasCurrentAnswer,
  isSubmitting,
  onPrevious,
  onNext,
  onSubmit,
}: TestNavigationProps) => {
  return (
    <div className="flex justify-between pt-4">
      <Button
        variant="outline"
        onClick={onPrevious}
        disabled={currentQuestionIndex === 0}
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        Previous
      </Button>

      {currentQuestionIndex === totalQuestions - 1 ? (
        <Button
          onClick={onSubmit}
          disabled={isSubmitting || !hasCurrentAnswer}
        >
          <Check className="mr-2 h-4 w-4" />
          {isSubmitting ? "Submitting..." : "Submit Test"}
        </Button>
      ) : (
        <Button
          onClick={onNext}
          disabled={!hasCurrentAnswer}
        >
          Next
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      )}
    </div>
  );
};